import { connect } from "react-redux";

import ModalsContainer from "./ModalsContainer";

const mapStateToProps = state => ({ modals: state.modals });

export default connect(mapStateToProps)(ModalsContainer);
